export { CategorizationService } from './categorization.service';
export { CategorizationAncestorUtils, CategoryAncestryDetails } from './utils';

export type OptionsMapNode = {
  name: string;
  id: string;
  children?: OptionsMapNode[];
};
